import { render, staticRenderFns } from "./RelatorioProfessorNotasPendentes.vue?vue&type=template&id=23728194&scoped=true&"
import script from "./RelatorioProfessorNotasPendentes.vue?vue&type=script&lang=js&"
export * from "./RelatorioProfessorNotasPendentes.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioProfessorNotasPendentes.vue?vue&type=style&index=0&id=23728194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23728194",
  null
  
)

export default component.exports